/**
 * @desc 分页
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<defs.rms.IPage<defs.rms.PaymentBankResponseDto>>;
export function request(params: API.rms.paymentBank.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentBank/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
